import NavLinks from "./NavLinks";

function RegularNav(props) {
  return (
    <>
      <nav className="regnav left">
        <NavLinks></NavLinks>
      </nav>
    </>
  );
}

export default RegularNav;
